import { render, staticRenderFns } from "./Projet.vue?vue&type=template&id=4123b720&scoped=true"
import script from "./Projet.vue?vue&type=script&lang=js"
export * from "./Projet.vue?vue&type=script&lang=js"
import style0 from "./Projet.vue?vue&type=style&index=0&id=4123b720&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4123b720",
  null
  
)

export default component.exports